export default class Trasnfer {
  constructor() {
    this.handleBankBrands();
  }

  handleBankBrands() {
    const brands = document.querySelectorAll(".wvp-transfer-brand");
    const bank = document.querySelector("#wvp-transfer-bank");

    if (bank) {
      brands.forEach((brand) => {
        brand.addEventListener("click", () => {
          this.clearSelectedBrands();

          brand.classList.add("wvp-transfer-brand-selected");
          bank.value = brand.getAttribute("data-bank");
        });
      });
    }
  }

  clearSelectedBrands() {
    const brands = document.querySelectorAll(".wvp-transfer-brand-selected");

    brands.forEach((brand) => {
      brand.classList.remove("wvp-transfer-brand-selected");
    });
  }
}
